/**
 * Languages.
 * @module constants/Languages
 */

module.exports = {
  en: 'English',
  de: 'Deutsch',
  nl: 'Nederlands',
  ro: 'Română',
  ja: '日本語',
  pt: 'Português',
  pt_BR: 'Português (Brasil)',
  es: 'Spanish',
  it: 'Italian',
  eu: 'Euskara',
};
